import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Title } from 'ui-library';
import './SetupWithdrawalPlan.css';

interface SetupWithdrawalPlanProps {
    /** Whether the withdrawal plan is currently selected */
    value: any;
    /** Callback triggered when a selection is made */
    onChange?: (value: any) => void;
    /** Optional flag to disable the 'Yes' option with a warning */
    disableWithdrawalOption?: boolean;
}

const SetupWithdrawalPlan: FC<SetupWithdrawalPlanProps> = ({
    value,
    onChange,
    disableWithdrawalOption,
}) => {
    const { t } = useTranslation();

    return (
        <div className="setupWithdrawalPlan">
            <Title type={2}>{t('setupWithdrawalPlan.labels.title')}</Title>
            <div className="setupWithdrawalPlan__ButtonWrapper">
                <Button
                    onClick={() => onChange?.(true)}
                    type={value ? 'primary' : 'secondary'}
                    disabled={disableWithdrawalOption}
                >
                    {t('setupWithdrawalPlan.buttons.yes')}
                </Button>
                <Button
                    onClick={() => onChange?.(false)}
                    type={!value ? 'primary' : 'secondary'}
                >
                    {t('setupWithdrawalPlan.buttons.no')}
                </Button>
                {disableWithdrawalOption && (
                    <p className="setupWithdrawalPlan__Warning">
                        {t('setupWithdrawalPlan.labels.warnMessage')}
                    </p>
                )}
            </div>
        </div>
    );
};

export default SetupWithdrawalPlan;
